/**
 * An `UP NEXT` thumbnail — the small desaturated cover both TO-DO panels print
 * after the featured one.
 *
 * There were two copies of this (one per tree) from the day GOTY shipped; MY
 * INTERESTS growing the same panel on 2026-08-24 would have made four. The
 * only difference between them was ever the size, so that is the prop: 48px on
 * desktop, 34px on the phone, and the initials scale with it.
 *
 * Not draggable and not clickable on purpose — it is a queue preview, and the
 * one game you can act on is the featured cover above it.
 */

import type { CapsuleVM } from '../store/selectors.ts';

import { CoverArt } from './CoverArt.tsx';
import { useArt } from './useArt.ts';

export function TodoThumb({ n, w, fs }: { n: CapsuleVM; w: number; fs: number }): JSX.Element {
  const art = useArt(n.id + 'p', n.coverCands);
  return (
    <div
      style={{
        position: 'relative',
        width: w,
        flex: 'none',
        aspectRatio: '2/3',
        border: '1px solid var(--gt-border-2)',
        background: n.fall,
        overflow: 'hidden',
        filter: 'saturate(.6)',
      }}
    >
      <CoverArt style={{ position: 'absolute', inset: 0 }} fs={fs} ini={n.ini} hasCover={art.hasCover} cover={art.cover} />
    </div>
  );
}
